/* global confirm */
define((require) => {
    "use strict";

    var CustomJsItemView  = require("editor/ui/settings/integrations/customJs/CustomJsItemView"),
        LoggedInUserState = require("shared/ui/user/LoggedInUserState"),
        Marionette        = require("marionette");

    return Marionette.CollectionView.extend("CustomJsCollectionView", {

        tagName: "ul",

        className: "custom-js-collection",

        itemView: CustomJsItemView,

        // Catch "edit" events triggered in CustomJsItemView.
        onItemviewEdit: function(customJsPrototypeAction) {
            this.trigger("edit", customJsPrototypeAction.model);
        },

        // Catch "edit" events triggered in CustomJsItemView.
        onItemviewDelete: function(customJsPrototypeAction) {
            // Double check that we do not try and delete an action that is in use.
            if (customJsPrototypeAction.model.get("actionIsInUse")) {
                return;
            }

            if (!confirm("Are you sure you want to delete " + customJsPrototypeAction.model.get("action").get("name") + "?")) {
                return;
            }

            var self = this;
            customJsPrototypeAction.model.destroy()
                .fail(() => {
                    // If the save failed, insert the action back into the collection.
                    LoggedInUserState.get("prototypeActionCollection").add(customJsPrototypeAction.model);
                    self.trigger("refresh");
                });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/customJs/CustomJsCollectionView.js